import { copyToClipboard } from 'utils/copyToClipboard';
import { IconCopy } from 'components/Icons';
import { Dispatch, SetStateAction } from 'react';
import { useDataCollection } from 'modules/AnalyticsCollection/AnalyticsCollectionProvider';
import { ModelLanguage } from 'modules/EntityReference/CodeSnippets';
import { CodeSnippetAction } from './actionBtn/CodeSnippetAction';
import { CodeSnippet } from './CodeSnippet';
import { CodeSteps } from './CodeSteps';
import { Dropdown } from './dropdown/Dropdown';
import { getBashSnippet } from './snippets/getCodeSnippet';

type Props = {
  language: ModelLanguage;
  setLanguge: Dispatch<SetStateAction<ModelLanguage>>;
  languageOptions: {
    value: ModelLanguage;
    name: ModelLanguage;
  }[];
};

export const InstallAndAuthenticate = ({ language, setLanguge, languageOptions }: Props) => {
  const { track } = useDataCollection();
  const bashSnippet = getBashSnippet(language);

  const onDropdownChange = (selectedOption: { value: string }) => {
    setLanguge(selectedOption.value as ModelLanguage);
    track('Playground -> Codesnippet SDK Selected', { sdk: selectedOption.value });
  };

  const onCopyBtnClikced = (codeSnippet: string) => {
    copyToClipboard(codeSnippet, 'Code copied to clipboard!')();
  };

  return (
    <div className="code-block">
      <CodeSteps
        stepNumnber={1}
        title="Install & Authenticate"
        dropdown={
          <Dropdown
            options={languageOptions.map((each) => ({
              value: each.value,
              label: each.name,
              icon: <></>,
            }))}
            onChange={onDropdownChange}
          />
        }
      />
      <div className="snippet-block">
        <CodeSnippet
          header={
            <>
              <span className="title">Bash</span>
              <CodeSnippetAction title="Copy" onClick={() => onCopyBtnClikced(bashSnippet)} icon={<IconCopy size={16} />} />
            </>
          }
          code={bashSnippet}
          language="bash"
        />
      </div>
    </div>
  );
};
